import { BaseFiltroPaginate } from "resources/enums/paginate";
import { useCallback, useState } from "react";
import { FiltroOrcamentos } from "core/features/orcamento/typings";

function useFiltroOrcamentos() {
  const [filtro, setFiltro] = useState<FiltroOrcamentos>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
    statusId: undefined,
  });

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroOrcamentos>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroOrcamentos;
